<div class="NonIdealState">
    <h1>Page not found</h1>
    <br />
    <p>The page you are looking for does not exist.</p>
    <br />
    <a matButton="filled" [routerLink]="['/', 'home']"> <mat-icon>shortcut</mat-icon> Go to dashboard </a>
</div>
